import { render, staticRenderFns } from "./SimpleCard.vue?vue&type=template&id=64e08f9c"
import script from "./SimpleCard.vue?vue&type=script&lang=js"
export * from "./SimpleCard.vue?vue&type=script&lang=js"
import style0 from "./SimpleCard.vue?vue&type=style&index=0&id=64e08f9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports